import CardBody from 'components/card/CardBody'
import CustomCard from 'components/card/CustomCard'
import CustomCardHeader from 'components/card/CustomCardHeader'
import FormLabel from 'components/form/FormLabel'
import { ImageUploadCard } from 'components/ImageUploadCard'
import TableItemLoader from 'components/TableItemLoader'
import ToggleSwitch from 'components/toggleSwitch/ToggleSwitch'
import { useDispatch, useSelector } from 'react-redux'
import { updateRemoteConfig } from 'redux/slices/remoteConfigSlice'

const QuickeePromotionSection = ({ fetchRemoteConfigAction }) => {
  const dispatch = useDispatch()
  const { loading, error, processing, remoteConfig } = useSelector(
    (state) => state.remoteConfig,
  )

  const quickee = remoteConfig?.config?.quickee ?? {}
  const cartPopup = quickee.cart_popup ?? {}
  const cartBanner = quickee.cart_banner ?? {}

  const updateQuickee = ({ popup, banner }) => {
    dispatch(
      updateRemoteConfig({
        configType: 'Quickee promotion',
        configPayload: {
          config: {
            quickee: {
              ...quickee,
              ...(popup && { cart_popup: { ...cartPopup, ...popup } }),
              ...(banner && { cart_banner: { ...cartBanner, ...banner } }),
            },
          },
        },
      }),
    )
  }

  return (
    <div className="flex-1">
      <CustomCard>
        <CustomCardHeader contentPosition="none">
          <h2 className="text-white text-2xl">Quickee Promotion</h2>
        </CustomCardHeader>
        {loading || error.length > 0 ? (
          <TableItemLoader
            loading={loading}
            error={error}
            retry={fetchRemoteConfigAction}
            isCircular={true}
          />
        ) : (
          <CardBody>
            <div className="flex items-center justify-between space-x-6 mb-6">
              <div className="flex items-center space-x-3">
                <FormLabel label="Cart Popup" />
                <ToggleSwitch
                  isChecked={cartPopup.active ?? false}
                  onChange={() =>
                    !processing &&
                    updateQuickee({ popup: { active: !cartPopup.active } })
                  }
                />
              </div>
              <div className="flex items-center space-x-3">
                <FormLabel label="Cart Banner" />
                <ToggleSwitch
                  isChecked={cartBanner.active ?? false}
                  onChange={() =>
                    !processing &&
                    updateQuickee({ banner: { active: !cartBanner.active } })
                  }
                />
              </div>
            </div>
            <ImageUploadCard
              initialImage={cartBanner.banner_image ?? ''}
              title="Banner Image"
              permanentRemove={false}
              disabled={processing}
              onImageUploaded={(image) =>
                updateQuickee({ banner: { banner_image: image } })
              }
              onImageRemoved={() =>
                updateQuickee({ banner: { banner_image: '' } })
              }
            />
            {!!cartBanner.banner_image && (
              <div className="w-full h-64 mb-4 border rounded-md overflow-hidden bg-gray-100 flex-shrink-0">
                <img
                  src={cartBanner.banner_image}
                  className="w-full h-full object-contain"
                  alt="banner"
                />
              </div>
            )}
          </CardBody>
        )}
      </CustomCard>
    </div>
  )
}

export default QuickeePromotionSection
